export const TYPENAMES = {
  Flag: 'FlagsAdminV1Flag',
  Segment: 'FlagsAdminV1Segment',
  MaterializedSegment: 'FlagsAdminV1MaterializedSegment',
  Metric: 'MetricsV1Metric',
  Measurement: 'MetricsV1Measurement',
  EventDefinition: 'EventsAdminV1EventDefinition',
  Surface: 'WorkflowV1Surface',
  Project: 'CollaborationV1Project',
  Initiative: 'WorkflowV1Initiative',
  Collection: 'CollectionsV1Collection',
  AssignmentTable: 'MetricsV1AssignmentTable',
  FactTable: 'MetricsV1FactTable',
  Entity: 'MetricsV1Entity',
  WorkflowInstance: 'WorkflowV1WorkflowInstance',
  Issue: 'ObservationsV1Issue',
  Chat: 'ConversationsV2Chat',
  Pulse: 'PulseV1Pulse',
} as const;
